import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const LineContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 25px auto;
`;

const LineLabel = styled.div`
  flex: 1;
`;

const LineValue = styled.div`
  flex: 1;
  text-align: right;
  font-weight: bold;
`;

const LineItem = ({ label, value }) => (
  <LineContainer>
    <LineLabel>{label}</LineLabel>
    <LineValue>{value}</LineValue>
  </LineContainer>
);

LineItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default LineItem;
